// ============================================================================
// POLISH TRANSLATIONS - CHAPTER 5: WCZESNY KOŚCIÓŁ
// ============================================================================
// Poziomy 53-65 (13 poziomów, 39 pytań)

export const chapter5Translations = {
  name: "Wczesny Kościół",
  description: "Otrzymacie moc...",
  
  spiritualWisdom: {
    principle: "Duch Święty daje moc i odwagę do świadczenia",
    scripture: "Gdy Duch Święty zstąpi na was, otrzymacie moc i będziecie moimi świadkami (Dzieje Apostolskie 1:8)",
    application: "Kościół rodzi się w ogniu Ducha i rośnie przez odważne świadectwo"
  },
  
  levels: {
    53: {
      name: "Wniebowstąpienie",
      challenge: "Będziecie moimi świadkami... aż po krańce ziemi...",
      easy: {
        question: "Ile dni po zmartwychwstaniu Jezus wstąpił do nieba?",
        options: ["30 dni", "40 dni", "50 dni", "60 dni"],
        hint: "Biblijna liczba przygotowania",
        funFact: "☁️ 40 dni intensywnego nauczania przed misją światową!"
      },
      medium: {
        question: "Jaką obietnicę złożył Jezus przed wniebowstąpieniem?",
        options: [
          "Że wróci natychmiast",
          "Że pośle Ducha Świętego z mocą",
          "Że zbuduje kościół",
          "Że ukarze złych"
        ],
        hint: "Moc z wysoka",
        funFact: "⚡ Obietnica Ducha Świętego - przemiana przestraszonych uczniów!"
      },
      hard: {
        question: "Co symbolizuje wniebowstąpienie w naszym życiu duchowym?",
        options: [
          "Koniec obecności Jezusa",
          "Jezus panuje w niebie i wstawia się za nami",
          "Ostateczne pożegnanie",
          "Symboliczny mit"
        ],
        hint: "Chodzi o żywą obecność w chwale",
        funFact: "👑 Jezus zasiadł po prawicy Boga, panuje i wstawia się za nami!"
      }
    },
    
    54: {
      name: "Pięćdziesiątnica",
      challenge: "Wszyscy zostali napełnieni Duchem Świętym i zaczęli mówić...",
      easy: {
        question: "Ile dni po wniebowstąpieniu nastąpiła Pięćdziesiątnica?",
        options: ["7 dni", "10 dni", "14 dni", "20 dni"],
        hint: "Około dziesięciu dni",
        funFact: "🔟 10 dni gorliwej modlitwy przygotowuje na wylanie Ducha!"
      },
      medium: {
        question: "W jakiej postaci objawił się Duch Święty?",
        options: [
          "Jak gwałtowny wiatr",
          "Jak rozdzielone języki ognia",
          "Jak gołębica",
          "Jak światło"
        ],
        hint: "Płomienie spoczywające na każdym uczniu",
        funFact: "🔥 Języki ognia: Duch daje odwagę i dar języków!"
      },
      hard: {
        question: "Co reprezentuje Pięćdziesiątnica dla Kościoła powszechnego?",
        options: [
          "Izolowane wydarzenie historyczne",
          "Oficjalne narodziny Kościoła misyjnego",
          "Cud z ciekawości",
          "Początek świąt"
        ],
        hint: "Chodzi o akt urodzenia Kościoła",
        funFact: "🎂 Pięćdziesiątnica = urodziny Kościoła, początek misji światowej!"
      }
    },

    55: {
      name: "Pierwsze Kazanie Piotra",
      challenge: "Co mamy czynić, bracia? Nawróćcie się...",
      easy: {
        question: "Ile osób zostało ochrzczonych po kazaniu Piotra?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "Trzy tysiące dusz",
        funFact: "🌊 3000 chrztów w jeden dzień - niezwykłe przebudzenie duchowe!"
      },
      medium: {
        question: "O co Piotr oskarżył tłum?",
        options: [
          "Niewiedzy",
          "Ukrzyżowania Jezusa, Mesjasza",
          "Braku wiary",
          "Hipokryzji"
        ],
        hint: "Najwyższy grzech przeciwko Synowi Bożemu",
        funFact: "⚔️ Piotr, który zaparł się Jezusa, teraz proklamuje Jego boskość!"
      },
      hard: {
        question: "Jak przemiana Piotra pokazuje działanie Ducha Świętego?",
        options: [
          "Stał się bardziej wykształcony",
          "Z bojaźliwego i chwiejnego stał się odważny i niezłomny w wierze",
          "Zdobył władzę",
          "Zmienił się jego charakter"
        ],
        hint: "Chodzi o uświęcenie przez Ducha",
        funFact: "🗿 'Chwiejna trzcina' staje się 'solidną skałą' - moc przemiany!"
      }
    },

    56: {
      name: "Pierwsza Wspólnota",
      challenge: "Trwali w nauce apostołów i we wspólnocie...",
      easy: {
        question: "Jak pierwsi chrześcijanie dzielili się majątkiem?",
        options: [
          "Każdy zachował swoje",
          "Dzielili się wszystkim",
          "Tylko bogaci dawali",
          "Przez prawny obowiązek"
        ],
        hint: "Dobrowolne dzielenie się majątkiem",
        funFact: "🤝 Braterska miłość tak intensywna, że dobrowolnie dzielili się wszystkim!"
      },
      medium: {
        question: "Na co pierwsi chrześcijanie poświęcali swój czas?",
        options: [
          "Tylko na biznes",
          "Naukę, wspólnotę, łamanie chleba, modlitwę",
          "Tylko pracę",
          "Rekreację"
        ],
        hint: "Cztery filary życia wspólnotowego",
        funFact: "⛪ Nauka, wspólnota, Eucharystia, modlitwa - fundamenty Kościoła!"
      },
      hard: {
        question: "Dlaczego ta pierwsza wspólnota była tak atrakcyjna?",
        options: [
          "Byli bogaci",
          "Autentyczna miłość i radość promieniowały z ich jedności",
          "Obiecywali cuda",
          "Krytykowali innych"
        ],
        hint: "Chodzi o żywe świadectwo miłości",
        funFact: "✨ 'Patrzcie, jak oni się miłują!' - świadectwo bardziej przekonujące niż słowa!"
      }
    },

    57: {
      name: "Uzdrowienie Chromego",
      challenge: "Srebra i złota nie mam, ale co mam, to ci daję...",
      easy: {
        question: "Jak długo ten człowiek był chromy?",
        options: [
          "20 lat",
          "30 lat", 
          "Od urodzenia",
          "10 lat"
        ],
        hint: "Niepełnosprawność od urodzenia",
        funFact: "🚶 40 lat niepełnosprawności natychmiast uzdrowione w imię Jezusa!"
      },
      medium: {
        question: "W czyim imieniu Piotr uzdrowił chromego?",
        options: [
          "W imię Boga",
          "W imię Jezusa Chrystusa z Nazaretu",
          "W swoim imieniu",
          "W imię Abrahama"
        ],
        hint: "Imię ponad wszelkie imię",
        funFact: "✊ Imię Jezusa nadal dokonuje cudów przez apostołów!"
      },
      hard: {
        question: "Co symbolizuje to uzdrowienie dla Ewangelii?",
        options: [
          "Prosty cud medyczny",
          "Całkowite zbawienie, które przynosi Jezus: duchowe i fizyczne",
          "Moc apostołów",
          "Dobroczynność dla biednych"
        ],
        hint: "Chodzi o całkowite zbawienie człowieka",
        funFact: "🩺 Jezus uzdrawia duszę i ciało - całkowite zbawienie człowieka!"
      }
    },

    58: {
      name: "Początek Prześladowań",
      challenge: "Trzeba bardziej słuchać Boga niż ludzi...",
      easy: {
        question: "Kto aresztował Piotra i Jana po uzdrowieniu chromego?",
        options: [
          "Rzymianie",
          "Saduceusze i kapłani",
          "Lud",
          "Piłat"
        ],
        hint: "Żydowskie władze religijne",
        funFact: "⛓️ Pierwsze prześladowania religijne - Ewangelia zakłóca establishment!"
      },
      medium: {
        question: "Co władze zakazały apostołom?",
        options: [
          "Opuszczać Jerozolimę",
          "Nauczać więcej w imię Jezusa",
          "Czynić więcej cudów",
          "Modlić się więcej"
        ],
        hint: "Zakaz głoszenia",
        funFact: "🚫 Próba uciszenia prawdy - niemożliwe zatrzymać Ewangelię!"
      },
      hard: {
        question: "Jak apostołowie zareagowali na zakaz?",
        options: [
          "Przestraszyli się i ulegali",
          "Stwierdzili, że trzeba bardziej słuchać Boga niż ludzi",
          "Negocjowali",
          "Uciekli"
        ],
        hint: "Chodzi o lojalność wyższą niż prawo ludzkie",
        funFact: "⚖️ Obywatelskie nieposłuszeństwo dla posłuszeństwa Bogu - odwaga przekonań!"
      }
    },

    59: {
      name: "Ananiasz i Safira",
      challenge: "Nie skłamałeś ludziom, ale Bogu...",
      easy: {
        question: "Jakie kłamstwo wypowiedzieli Ananiasz i Safira?",
        options: [
          "Nic nie sprzedali",
          "Zatrzymali część, mówiąc że dają wszystko",
          "Byli biedni",
          "Nie byli małżeństwem"
        ],
        hint: "Kłamstwo o darowanej kwocie",
        funFact: "💰 Zatrzymanie części było dozwolone, kłamstwo o ofierze nie!"
      },
      medium: {
        question: "Co się z nimi stało po kłamstwie?",
        options: [
          "Zostali przebaczeni",
          "Natychmiast umarli",
          "Zostali wygnani",
          "Pokutowali"
        ],
        hint: "Natychmiastowa surowa kara",
        funFact: "⚱️ Surowy sąd, aby zachować czystość nowonarodzonego Kościoła!"
      },
      hard: {
        question: "Dlaczego tak surowa kara na początku Kościoła?",
        options: [
          "Bóg był okrutny",
          "Aby ustanowić świętość wymaganą od wspólnoty",
          "Aby przestraszyć",
          "Przypadek"
        ],
        hint: "Chodzi o zachowanie integralności duchowej",
        funFact: "🔥 Wysokie standardy na początku, aby ustanowić kulturę świętości!"
      }
    },

    60: {
      name: "Siedmiu Diakonów",
      challenge: "Wybierzcie spośród siebie siedmiu mężów cieszących się dobrą sławą...",
      easy: {
        question: "Ilu diakonów zostało wybranych?",
        options: ["5", "6", "7", "12"],
        hint: "Liczba doskonałości",
        funFact: "7️⃣ Siedmiu diakonów do służby - boska organizacja Kościoła!"
      },
      medium: {
        question: "Jaka była ich główna rola?",
        options: [
          "Głosić Ewangelię",
          "Służyć przy stołach i pomagać wdowom",
          "Chrzcić nowych nawróconych",
          "Zarządzać finansami"
        ],
        hint: "Służba społeczna i materialna",
        funFact: "🍽️ Służba przy stołach = pierwsza chrześcijańska organizacja charytatywna!"
      },
      hard: {
        question: "Co ta organizacja objawia o chrześcijańskiej wizji służby?",
        options: [
          "Praca materialna jest niższa",
          "Służba duchowa i materialna są jednakowo święte",
          "Trzeba oddzielać świętość od świeckości",
          "Tylko kapłani naprawdę służą"
        ],
        hint: "Chodzi o świętość wszelkiej służby miłości",
        funFact: "✨ Służba przy stołach z taką samą godnością jak głoszenie - wszelka służba jest święta!"
      }
    },

    61: {
      name: "Szczepan, Pierwszy Męczennik",
      challenge: "Panie, nie poczytuj im tego grzechu! Powiedziawszy to, zasnął...",
      easy: {
        question: "Jaka była rola Szczepana w Kościele?",
        options: ["Apostoł", "Diakon", "Kapłan", "Prorok"],
        hint: "Jeden z siedmiu wybranych do służby",
        funFact: "✨ Szczepan: diakon staje się potężnym ewangelizatorem i pierwszym męczennikiem!"
      },
      medium: {
        question: "O co Szczepan oskarżył żydowskich przywódców?",
        options: [
          "Korupcję",
          "Że zawsze sprzeciwiali się Duchowi Świętemu",
          "Hipokryzję",
          "Chciwość"
        ],
        hint: "Historyczny opór przeciwko Bogu",
        funFact: "📜 Szczepan podsumowuje historię: ciągły bunt przeciwko Bogu!"
      },
      hard: {
        question: "Jak Szczepan umarł i co objawia jego postawa?",
        options: [
          "W gniewie wobec oprawców",
          "Przebaczając jak Jezus na krzyżu",
          "W rozpaczy",
          "Przeklinając wrogów"
        ],
        hint: "Chodzi o doskonałe naśladowanie Chrystusa",
        funFact: "💝 Przebaczenie oprawcom: Szczepan doskonale odtwarza postawę Jezusa!"
      }
    },

    62: {
      name: "Filip i Etiop Eunuch",
      challenge: "Jakżeż mogę zrozumieć, jeśli mi nikt nie wyjaśni?",
      easy: {
        question: "Co eunuch czytał w wozie?",
        options: [
          "Psalmy",
          "Proroka Izajasza",
          "Księgę Rodzaju",
          "Przypowieści"
        ],
        hint: "Prorok męki Mesjasza",
        funFact: "📖 Izajasz 53 - doskonała przepowiednia o Jezusie czytana przez szczerze poszukującego!"
      },
      medium: {
        question: "Jak Filip wyjaśnił fragment Izajasza?",
        options: [
          "Opowiedział o starożytnej historii",
          "Głosił Jezusa z tego tekstu",
          "Przeprowadził wykład z teologii",
          "Skrytykował interpretację"
        ],
        hint: "Pismo naturalnie prowadzi do Chrystusa",
        funFact: "✝️ Całe Pismo zbiegało się w Jezusie - klucz do zrozumienia!"
      },
      hard: {
        question: "Co symbolizuje nawrócenie etiopa eunucha?",
        options: [
          "Izolowane nawrócenie",
          "Uniwersalność Ewangelii dla wszystkich ras i stanów",
          "Wyższość określonej narodowości",
          "Szczególny przypadek"
        ],
        hint: "Chodzi o otwarcie na narody",
        funFact: "🌍 Etiop, eunuch, minister: Ewangelia łamie wszystkie bariery!"
      }
    },

    63: {
      name: "Nawrócenie Szawła z Tarsu",
      challenge: "Szawle, Szawle, czemu mnie prześladujesz?",
      easy: {
        question: "Co Szaweł robił przed nawróceniem?",
        options: [
          "Głosił Ewangelię",
          "Prześladował chrześcijan",
          "Był neutralny",
          "Tylko się uczył"
        ],
        hint: "Zaciekły wróg uczniów",
        funFact: "⚔️ Szaweł oddychał groźbami i morderstwem przeciwko uczniom Jezusa!"
      },
      medium: {
        question: "Na której drodze Jezus objawił się Szawłowi?",
        options: [
          "Droga do Jerozolimy",
          "Droga do Damaszku",
          "Droga do Gazy",
          "Droga do Antiochii"
        ],
        hint: "Miasto w Syrii",
        funFact: "🛤️ Droga do Damaszku = najsłynniejsze miejsce przemiany w historii!"
      },
      hard: {
        question: "Jak to nawrócenie pokazuje łaskę Bożą?",
        options: [
          "Bóg nawraca tylko dobrych ludzi",
          "Łaska może przemienić najgorszego wroga w największego apostoła",
          "Nawrócenie było zasłużone",
          "Szaweł był już blisko Boga"
        ],
        hint: "Chodzi o przemieniaćą moc łaski",
        funFact: "⚡ Od największego prześladowcy do największego misjonarza - cud łaski!"
      }
    },

    64: {
      name: "Piotr i Korneliusz",
      challenge: "Naprawdę przekonałem się, że Bóg nie ma względu na osoby...",
      easy: {
        question: "Jaki był zawód Korneliusza?",
        options: [
          "Kupiec",
          "Setnik rzymski",
          "Kapłan",
          "Uczony w Piśmie"
        ],
        hint: "Oficer rzymskiej armii",
        funFact: "🎖️ Pierwszy oficjalnie nawrócony poganin - otwarcie na niżydów!"
      },
      medium: {
        question: "Jaką wizję miał Piotr przed spotkaniem z Korneliuszem?",
        options: [
          "Anioł mówiący",
          "Płótno ze zwierzętami czystymi i nieczystymi",
          "Jezus się objawiający",
          "Zniszczona świątynia"
        ],
        hint: "Wizja o czystości i nieczystości",
        funFact: "🕊️ Płótno ze zwierzętami: Bóg znosi rozróżnienia pokarmów i ras!"
      },
      hard: {
        question: "Jaką rewolucyjną zasadę ustanowiło to nawrócenie?",
        options: [
          "Rzymianie są wyżsi",
          "Bóg nie ma względu na osoby - zbawienie uniwersalne",
          "Trzeba porzucić tradycje",
          "Obrzezanie jest bezużyteczne"
        ],
        hint: "Chodzi o uniwersalność zbawienia",
        funFact: "🌍 Rewolucja duchowa: Ewangelia jest dla wszystkich narodów bez wyjątku!"
      }
    },

    65: {
      name: "Kościół w Antiochii",
      challenge: "W Antiochii uczniowie po raz pierwszy nazwani zostali chrześcijanami...",
      easy: {
        question: "Jak po raz pierwszy nazwano uczniów w Antiochii?",
        options: ["Uczniowie", "Chrześcijanie", "Wierzący", "Święci"],
        hint: "Nazwa, którą mamy do dziś",
        funFact: "✝️ 'Chrześcijanie' = 'mali Chrystusowie' - zaszczytna nazwa nadana przez pogan!"
      },
      medium: {
        question: "Kto przyszedł nauczać w Antiochii razem z Barnabą?",
        options: [
          "Piotr",
          "Paweł (Szaweł)",
          "Jakub",
          "Jan"
        ],
        hint: "Były prześladowca stawszy się apostołem",
        funFact: "👥 Barnaba szuka Pawła w Tarsie - początek służby Pawła!"
      },
      hard: {
        question: "Dlaczego Antiochia stała się tak ważna w historii chrześcijaństwa?",
        options: [
          "Była bogata",
          "Pierwsze centrum misyjne dla pogan",
          "Była dobrze położona",
          "Miała dobrych przywódców"
        ],
        hint: "Chodzi o ekspansję misyjną",
        funFact: "🚢 Antiochia: port wyjściowy wszystkich podróży misyjnych Pawła do Europy!"
      }
    }
  }
};

export default chapter5Translations;
